module.exports = __webpack_public_path__ + "assets/img/4fec756.4fec7567.png";